export type IconButtonSizes = 'x-small' | 'small' | 'medium' | 'large';

export type IconButtonThemes =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline';

export type IconButtonMode = 'light' | 'dark' | 'dark-white';

/**
 * Available icon options for IconButton component
 * - arrow-diagonal: Arrow pointing at 45-degree angle (upper right)
 * - arrow-down: Arrow pointing downward (90 degrees)
 * - arrow-right: Arrow pointing right (default direction)
 * - plus: Plus sign
 */
export type IconButtonIcon =
  | 'arrow-diagonal'
  | 'arrow-down'
  | 'arrow-right'
  | 'arrow-up'
  | 'plus'
  | 'times';

interface IconConfig {
  icon: string | string[];
  rotation?: number;
}

/**
 * Maps IconButtonIcon types to their FontAwesome icon names and rotation angles
 */
export const ICON_BUTTON_ICONS: Record<IconButtonIcon, IconConfig> = {
  'arrow-diagonal': { icon: 'arrow-right', rotation: -45 },
  'arrow-down': { icon: 'arrow-right', rotation: 90 },
  'arrow-right': { icon: 'arrow-right' },
  'arrow-up': { icon: 'arrow-right', rotation: 270 },
  plus: { icon: 'plus' },
  times: { icon: 'times' },
};

export interface IconButtonProps {
  id?: string;
  loading?: boolean;
  disabled?: boolean;
  pressed?: boolean;
  mode?: IconButtonMode;
  buttonTheme?: IconButtonThemes;
  customEventName: string;
  buttonSize?: IconButtonSizes;
  ariaLabel: string;
  icon: IconButtonIcon;
  iconRotation?: number;
}
